// document.addEventListener('DOMContentLoaded', function () {
//   const bannerEl = document.querySelector('.banner.swiper');
//   if (!bannerEl) return;

//   const slides = bannerEl.querySelectorAll('.swiper-slide');
//   const slideCount = slides.length;

//   if (slideCount <= 1) {
//     bannerEl.classList.remove('swiper');
//     bannerEl.querySelector('.swiper-wrapper').classList.remove('swiper-wrapper');

//     slides.forEach((slide) => {
//       slide.classList.remove('swiper-slide');
//     });

//     const paginationEl = bannerEl.querySelector('.custom_pagination');
//     if (paginationEl) paginationEl.style.display = 'none';

//     return;
//   }

//   let bannerSwiper = new Swiper('.banner.swiper', {
//     loop: true,
//     allowTouchMove: true,
//     autoplay: {
//       delay: 4000,
//       disableOnInteraction: false,
//     },
//     pagination: {
//       el: '.custom_pagination',
//       clickable: true,
//       renderBullet: function (index, className) {
//         return '<span class="custom-bullet ' + className + '"></span>';
//       },
//     },
//     on: {
//       init(swiper) {
//         loadActiveVideo(swiper);
//       },
//       slideChangeTransitionStart(swiper) {
//         loadActiveVideo(swiper);
//       },
//       slideChangeTransitionEnd(swiper) {
//         swiper.slides.forEach((slide, index) => {
//           if (index !== swiper.activeIndex) {
//             const video = slide.querySelector('video');
//             if (video) {
//               video.pause();
//               video.removeAttribute('src');
//               video.load();
//             }
//           }
//         });
//       }
//     }
//   });

//   window.bannerSwiper = bannerSwiper;

//   function loadActiveVideo(swiper) {
//     const activeSlide = swiper.slides[swiper.activeIndex];
//     if (!activeSlide) return;

//     const video = activeSlide.querySelector('video');
//     if (!video) return;

//     const source = video.querySelector('source[data-src]');
//     if (source) {
//       source.src = source.dataset.src;
//       source.removeAttribute('data-src');
//       video.load();
//     }

//     video.play().catch(() => {});
//   }
// });

document.addEventListener('DOMContentLoaded', function () {
  const bannerEl = document.querySelector('.banner.swiper');
  if (!bannerEl) return;

  const slides = bannerEl.querySelectorAll('.swiper-slide');
  const slideCount = slides.length;

  // Track which videos have been loaded - MOVED TO TOP LEVEL
  const loadedVideos = new Set();

  if (slideCount <= 1) {
    bannerEl.classList.remove('swiper');
    bannerEl.querySelector('.swiper-wrapper').classList.remove('swiper-wrapper');
    slides.forEach((slide) => slide.classList.remove('swiper-slide'));
    const paginationEl = bannerEl.querySelector('.custom_pagination');
    if (paginationEl) paginationEl.style.display = 'none';
    
    const slide = slides[0];
    const video = slide.querySelector('video');
    const imageWrap = slide.querySelector('.banner-image-wrap');
    
    if (video && imageWrap) {
      slide.addEventListener('mouseenter', function() {
        playVideoOnHover(video, imageWrap);
      });
    }
    
    return;
  }

  const bannerSwiper = new Swiper('.banner.swiper', {
    loop: true,
    allowTouchMove: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.custom_pagination',
      clickable: true,
      renderBullet(index, className) {
        return '<span class="custom-bullet ' + className + '"></span>';
      },
    },
    on: {
      init() {
        // Initialize videos but don't show them
        document.querySelectorAll('.banner-video').forEach(video => {
          video.style.display = 'none';
          // Don't preload to save bandwidth
          video.preload = 'none';
          // Ensure muted
          video.muted = true;
          // Add error event listener
          video.addEventListener('error', function() {
            console.log('Video error:', this.error);
          });
        });
        
        // Show all image wraps initially
        document.querySelectorAll('.banner-image-wrap').forEach(imgWrap => {
          imgWrap.style.display = 'block';
        });
      },
      slideChangeTransitionStart() {
        // When slide changes, handle previous slide's video
        const allSlides = document.querySelectorAll('.swiper-slide');
        allSlides.forEach(slide => {
          if (!slide.classList.contains('swiper-slide-active')) {
            const video = slide.querySelector('video');
            const imageWrap = slide.querySelector('.banner-image-wrap');
            if (video && imageWrap) {
              video.pause();
              video.currentTime = 0;
              video.style.display = 'none';
              imageWrap.style.display = 'block';
            }
          }
        });
      }
    }
  });


  function playVideoOnHover(video, imageWrap) {
    const media = video.closest('.banner-media');
if (media) {
  media.style.minHeight = media.offsetHeight + 'px';
}

    if (!video || !imageWrap) return;
    
    // Hide image, show video
    imageWrap.style.display = 'none';
    video.style.display = 'block';
    
    // Check if this video has already been loaded
    if (!loadedVideos.has(video)) {
      // First time loading this video
      loadedVideos.add(video);
      
      // Check if video source is in data-src attribute
      const source = video.querySelector('source[data-src]');
      if (source && source.hasAttribute('data-src')) {
        // Set the actual src from data-src
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      }
      
      // Load the video metadata
      video.load();
      
      // Wait for video to have enough data before playing
      const tryToPlay = () => {
        if (video.readyState >= 3) { // HAVE_FUTURE_DATA or HAVE_ENOUGH_DATA
          video.play().then(() => {
            console.log('Video playing successfully');
          }).catch(error => {
            console.log('Video play attempt failed:', error.name, error.message);
            // Try one more time after a short delay
            setTimeout(() => {
              video.play().catch(e => {
                console.log('Second play attempt failed:', e);
                // Fallback to image
                video.style.display = 'none';
                imageWrap.style.display = 'block';
              });
            }, 300);
          });
        } else {
          // Wait a bit more for video to load
          setTimeout(tryToPlay, 100);
        }
      };
      
      // Start trying to play
      tryToPlay();
    } else {
      // Video already loaded, just play it
      video.play().catch(error => {
        console.log('Playing already-loaded video failed:', error);
        // If play fails, restart video from beginning
        video.currentTime = 0;
        video.play().catch(e => {
          console.log('Restart play failed:', e);
          video.style.display = 'none';
          imageWrap.style.display = 'block';
        });
      });
    }
  }


  // Also handle banner-level mouse enter
  bannerEl.addEventListener('mouseenter', () => {
    const activeSlide = bannerSwiper.slides[bannerSwiper.activeIndex];
    const video = activeSlide.querySelector('video');
    const imageWrap = activeSlide.querySelector('.banner-image-wrap');
    
    if (video && imageWrap && video.paused) {
      playVideoOnHover(video, imageWrap);
    }
  });

  window.bannerSwiper = bannerSwiper;
});
